module.exports = __webpack_public_path__ + "assets/img/maintain.10e20196.png";